module.exports = __webpack_public_path__ + "static/img/hw.7b56fa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hw.png
// module id = tYFN
// module chunks = 0